import {z} from 'zod';

// GET /v1/bank-transfer-setting Response Schema
export const GetBankTransferSettingResponseBodySchema = z
  .object({
    isDefaultBankTransferAllowed: z.boolean(),
    invoiceMaturity: z.number().optional(),
    paymentLimit: z.number().optional(),
  })
  .nullable();

export type CorGetBankTransferSettingApiResponse = z.infer<
  typeof GetBankTransferSettingResponseBodySchema
>;

export type CorGetBankTransferSettingApiArg = void;

// PUT /v1/bank-transfer-setting Request Schema
export const UpdateBankTransferSettingRequestBodySchema = z
  .object({
    invoiceMaturity: z.number(),
    paymentLimit: z.number().min(0),
  })
  .nullable();

export type UpdateBankTransferSettingRequestBody = z.infer<
  typeof UpdateBankTransferSettingRequestBodySchema
>;

// PUT /v1/bank-transfer-setting Response Schema
export const UpdateBankTransferSettingResponseBodySchema = z
  .object({
    bankTransferSettingId: z.string().uuid().nullable().optional(),
  })
  .nullable();

export type CorUpdateBankTransferSettingApiResponse = z.infer<
  typeof UpdateBankTransferSettingResponseBodySchema
>;

export type CorUpdateBankTransferSettingApiArg = {
  body: UpdateBankTransferSettingRequestBody;
};

// POST /v1/bank-transfer-setting/allow-default Response
export type CorAllowDefaultBankTransferApiResponse = void;
export type CorAllowDefaultBankTransferApiArg = Record<string, never>;

// POST /v1/bank-transfer-setting/disallow-default Response
export type CorDisallowDefaultBankTransferApiResponse = void;
export type CorDisallowDefaultBankTransferApiArg = Record<string, never>;
